module.exports = __webpack_public_path__ + "static/google-sheets-export-833548ff45b333251a6c462c7b28232c.svg";